<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <v-list-item-avatar class="my-0">
      <v-icon small>fal fa-baby</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">出生地</v-list-item-subtitle>
      <v-list-item-title>{{ printBirthplace }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit"><v-icon small>fal fa-pencil</v-icon></v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter required
          label="出生地"
          :rules="rules.birthplace"
          maxlength="50"
          v-model="form.birthplace.content"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicBirthplace',
  components: {
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        birthplace: {
          id: '',
          content: ''
        }
      },
      rules: {
        birthplace: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.birthplace
      ) {
        this.$set(this.form, 'birthplace', {
          id: '' + (this.$props.data.birthplace.id ? this.$props.data.birthplace.id : 'new_birthplace'),
          content: this.$props.data.birthplace.content ? this.$props.data.birthplace.content : ''
        })
      } else {
        this.$set(this.form, 'birthplace', {
          id: 'new_birthplace',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'birthplace'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['birthplace', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'birthplace'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['birthplace', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'birthplace'
      )
    },
    printBirthplace () {
      return (
        this.$props.data &&
        this.$props.data.birthplace &&
        this.$props.data.birthplace.content
      ) ? this.$props.data.birthplace.content : '出生地'
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.birthplace &&
        this.$props.data.birthplace.content
      )
    }
  }
}
</script>
